import { Avatar, type AvatarProps } from './Avatar';
import { useMyWorkStatusDot } from '../../../hooks/useMyWorkStatusDot';

/**
 * **내** 프로필 아바타 — 점 색이 상태바에서 고른 근무 상태를 따라간다(2026-08-12 사용자 지적).
 *
 * 종전 호출부는 전부 `showStatus status="online"` 하드코딩이라 상태를 바꿔도 초록 그대로였다.
 * 이 래퍼로 바꾸기만 하면 상태바 ↔ 프로필 색이 한 출처(`workStatusStore`)에서 나온다.
 *
 * - 상태 미설정 → tone 없음 → 종전과 같은 초록(online). 화면이 조용히 달라지지 않는다.
 * - 다른 사람 아바타에는 쓰지 않는다(내 근무 상태를 남의 점에 칠하게 된다) — `Avatar` 를 그대로 쓸 것.
 */
export type MyStatusAvatarProps = Omit<AvatarProps, 'showStatus' | 'tone' | 'statusLabel'>;

export function MyStatusAvatar({ status = 'online', ...rest }: MyStatusAvatarProps) {
  const { tone, label } = useMyWorkStatusDot();
  return <Avatar {...rest} showStatus status={status} tone={tone} statusLabel={label} />;
}
